import { render, staticRenderFns } from "./BindsTablePagination.vue?vue&type=template&id=0068b71a&"
import script from "./BindsTablePagination.vue?vue&type=script&lang=js&"
export * from "./BindsTablePagination.vue?vue&type=script&lang=js&"
import style0 from "./BindsTablePagination.vue?vue&type=style&index=0&id=0068b71a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports